
export const pages = [
    {
        label: "Home",
        path: ""
    },
    {
        label: "Reel",
        path: "reel"

    },
    {
        label: "Albums",
        path: "albums"
    },
    {
        label: "Members",
        path: "members"
    },
    {
        label: "Contact",
        path:"contact"
    }
]